class Filter {

  constructor(options = {}) {
    this.$filtersWrapper = document.querySelector(options.filtersWrapper);
    this.$cards = document.querySelectorAll(options.cards);
    this.filtersName = options.filtersName;

    // data-* key name
    this.cat = 'cat';
    this.addEventListener();
  }

  addEventListener() {
    document.body.addEventListener('click', e => {
      this.handleFilterClick(e);
    })
  }


  handleFilterClick(e) {

    const isFilterWrapperClicked = this.$filtersWrapper.contains(e.target);
    if (isFilterWrapperClicked) {
      this.resetChanges();
      this.filterActus(e);
    }
  }

  filterActus(e) {
    e.target.classList.add('active');
    this.$cards.forEach(actu => {
      if (e.target.getAttribute(`data-${this.cat}`)) this.subFilter(e.target, actu, this.cat);
    })
  }

  subFilter(target, item, dataKey) {
    if (item.getAttribute(`data-${dataKey}`) != target.getAttribute(`data-${dataKey}`)) {
      item.style.display = 'none';
    }
  }


  resetChanges() {
    this.$filtersWrapper.querySelectorAll('button').forEach(button => button.classList.contains('active') && button.classList.remove('active'));
    this.$cards.forEach(actu => {
      if (actu.style.display === 'none') actu.style.display = 'block';
    })
  }
}

const filters = document.querySelector('.filters');

let options = {
  filtersName: ['categories'],
  filtersWrapper: '.module-archive .filters',
  cards: '.module-archive .cards .card',
};

if (filters) new Filter(options);



// WEBPACK FOOTER //
// ./scripts/modules/filters.js